const zh = {
  switchOrg: '组织切换成功！正在为您刷新页面...',
  userInfo: '个人信息',
  preferences: '系统设置',
  logout: '退出登录',
  invnManag: '仓储管理',
  orgHouse: '组织仓库',
  orderList: '订单列表',
  invnHistory: '盘点历史',
  salesMana: "销售管理",
  customMana: "终端客户管理",
  priceMana: "价格管理",
  orderMana: "订单管理",
  orgManag: '组织管理',
  bomMana: 'BOM 管理',
  memberManag: '成员管理',
  enableMember: '启用成员',
  disableMember: '禁用成员',
  categoryManag: '商品类目管理',
  productList: '商品列表',
  APPManagement: 'APP管理',
  productData: '生产数据录入',
  orderReviews: '订单评审',
  productionInfo: '生产资料制作',
  dataModule: '数据模块',
  orderReport: '订单报表',
  conLogout: '确定退出吗？',
  conLogoutTip1: '确定退出后将返回登录页面。',
  loggingOut: '正在为您退出登录...',
  selectOrg: '请选择组织',
  themeColor: '主题颜色',
  addSuccess: '添加成功',
  addFailed: '添加失败',
  updateSuccess: '更新成功',
  updateFailed: '更新失败',
  validaFailed: '校验失败',
  cancel: '取消',
  confirm: '确定',
  Loading: '加载中',
  upFail: '上传失败',
  plTryAgain: '请稍后再试',
  changeTip: '语言设置',
  switchOrgFailTip1: '当前组织无权限，无法进行切换！',
  switchOrgFailTip2: '组织切换失败，请重试！',
  loginFailTip1: '帐户不是后台管理员，请返回至用户登录。',
  loginFailTip2: '该账户没有参与组织或者没有权限，请联系管理员。',
  userAbnormalTip: '用户状态异常或权限不足，请联系管理员或重新登录！',
  orderProductionReports: '订单生产报表',
  orderReview: '订单评审',
  orderProductionData: '订单生产数据',
  purchaseMana: '采购管理',
  supplierMana: '供应商管理',
  materialControl: '物控管理',
  requirementList: '需求清单',
  noPassRequirement: '未审批需求清单',
  passedRequirement: '已审批需求清单',
  prod: '生产管理',
  finance: '财务管理',
  generatePurOrder: '生成采购订单',
  isAdmin: '系统管理员',

  okOrder: '销售正式订单',
  saleOrderFinish: '销售订单完结',
  waitOk: '需求评审',
  noPass: '评审待处理',
  passed: '需求已评审',
  purOrder: '采购订单管理',
  orderRe: '销售评审单',
  disableAndEnable: '禁用/启用',
  memberOperation: '成员操作',
  commodityEditor: '商品编辑',
  subcategoryEditing: '子类目编辑',
  orgOperation: '组织操作',
  reject: '需求退回',
  orgMana: "组织管理",
  orgInfoUpdate: "组织信息修改",
  orgMemberUpdate: "组织成员修改",
  wareMana: "仓库管理",
  inboundMana: "入库管理",
  outboundMana: "出库管理",
  inventoryMana: "盘点管理",
  orderTrack: '订单跟踪',
  pendingOrder: '未完成',
  doneOrder: '已完成',
  closeOrder: '已关闭',
  mcDataMt: '物控数据维护',
  mcReTemp: '物控需求模版',
  orderEntry: '订单数据录入',
  orderProdMt: '生产数据维护',
  purPendingPay: '未下单',
  purPayed: '已下单',
  purDone: '已完成',
  purOrderMt: '采购信息维护',
  requirementPurchase: '采购制单',
  reqM: '备料计划',
  DATAManage: "数据管理",
  QutationManage: '问询单管理',
  typeManage: '报价类目管理',
  submit: '保存',
  gategoryManage: '报价商品列表',
  printSetting: '打印设置',
  quotationManage: '报价管理',
  setExchange: '汇率设置',
  mainCurrency: '本位货币',
  company: '公司名称',
  address: '公司地址',
  plzCompany: '请输入公司名称',
  plzAddress: '请输入公司地址',
  orderManage: '订单管理',
  warehousePreparation: '出入库准备',
  warehouseManagement: '出入库管理',
  operationStatus: '操作状态',
  locationManagement: '库位管理',

  commodity: '产品管理',
  upSucc: "文件上传成功",
  addressM: "送货地址管理",
  addAddress: "添加地址",
  editAddress: "修改地址",
  inventoryManage: "库存管理",

  // 新增的翻译键
  purchaseOperation: '采购操作',
  manualQuotation: '人工报价',
  materialTracking: '齐料追踪',
  returnAndExchange: '退换货',
  pleaseFillRate: '请填写汇率',
  uploadImage: '上传图片',
  pleaseEnterName: '请输入名称',
  pleaseEnterAddress: '请输入地址',
  orderReportAll: '订单报表_全部',
  // 供应商管理
  disabledSupplier: '已停用供应商',
  confirmDisableSupplier: '确定停用么',
  confirmDisableSupplierDesc: '这将停用此供应商',
  confirmEnableSupplier: '确定启用么',
  confirmEnableSupplierDesc: '这将启用此供应商',


  // 报销类目
  reimburseCategory: '报销类目',
  approveTemplate: '审批模板',
  reimburseMana: '申请审批',
  myApplication: '我的申请',
  pendingApproval: '待我审批',
  allApplications: '全部申请',
  inOutDetail: '出入库明细',
  locationRefProducts: '库位商品关联',
  priceList: '采购价格列表',
  inventoryAlert: '库存预警',
  setInventoryAlert: '添加库存预警',
  purchaseRule: '采购条约',
  addPurchaseRule: '添加采购条约',
  ruleLangsPl: '请选择要添加的采购条约语言版本(如果没有你想添加的语言，请去系统设置里面完善)',
  printRule: '添加条约',
  notPrintRule: '不添加条约',
  noRuleConfig: '没有填写任何语言的采购条约，如需打印采购条约，请去系统设置中完善',
  purchaseRuleSet: '采购条约设置',
  factoryInventory: '产线仓库',
  equipmentManagement: '设备管理',
  width: "纸宽（竖版连续）",
  height: "纸高（竖版连续）",
  printTip: "系统打印纸张设置：{{width}}mm X {{height}}mm",
  printTipVertical: "竖版连续打印纸张设置（宽 X 高）",
  purInvItem: "送货单明细",
  locInvDetail: '库位出入库明细',
};

export default zh;
